import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@gasbuddy/react-components';

import styles from './styles.css';

const BPButton = ({ primary, secondary, tertiary, className, children, ...props }) => {
  let stylingClass = '';
  if (primary) {
    stylingClass = styles.bpPrimaryButton;
  }
  if (secondary) {
    stylingClass = styles.bpSecondaryButton;
  }

  return (
    <Button className={`${className} ${stylingClass} ${styles.button}`} {...props} primary={primary || tertiary} secondary={secondary}>
      {children}
    </Button>
  );
};

BPButton.propTypes = {
  primary: PropTypes.bool,
  secondary: PropTypes.bool,
  tertiary: PropTypes.bool,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

BPButton.defaultProps = {
  primary: false,
  secondary: false,
  tertiary: false,
  className: '',
};

export default BPButton;
